package com.castly.admin.dto

import kotlinx.serialization.Serializable

@Serializable
data class EpisodeListResponse(
    val items: List<EpisodeResponse>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)
